<div i18nRerenderOnLanguageChange></div>
@if (nachrichten?.length) {
    <ul class="ba-message-list" id="message-list">
        @for (nachricht of nachrichten; track nachricht.nachrichtId) {
            <li class="ba-tile ba-icon {{ getSpecificClassList(nachricht) }}">
                <pf-nachricht-list-item
                        [nachrichtId]="nachricht.nachrichtId"
                        [gelesen]="nachricht.gelesen"
                        [mitAnhang]="nachricht.anhang"
                        [dateTime]="getPostfachFormat(nachricht.datum)"
                        [betreff]="nachricht.betreff"
                        [bezug]="nachricht.bezug"
                        [showBezug]="!userAccountService.isZuwanderungsinteressierter()"
                        [nachrichtFolder]="nachrichtFolder"
                        [vNiveauAusreichend]="getVNiveauAusreichend(nachricht)"
                        [erstleser]="getErstleserIfNotSelf(nachricht.leserName, nachricht.leserId)"
                        [vertreter]="getAutorIfVertreter(nachricht)"
                        [trustLevel]="nachricht.vNiveau"
                        [nachrichtActions]="showNachrichtActions(nachricht) ? getNachrichtAction(nachrichtFolder, nachricht) : []"
                        [nachrichtReadLink]="'/ordner/' + nachricht.ordnerType + '/nachricht/' + nachricht.nachrichtId"
                        [nachrichtType]="nachricht.typ"
                        (buttonClicked)="onNachrichtActionButtonClicked($event, nachricht)"
                        (stepUpClicked)="onStepUpUpClicked(nachricht)"
                ></pf-nachricht-list-item>
            </li>
        }
    </ul>
} @else {
    <div class="ba-message-list">
        <pf-hinweisbox [boxType]="HinweisboxTypeEnum.INFO" boxId="no-messages">{{ 'mailbox.no-messages' | i18next }}
        </pf-hinweisbox>
    </div>
}

<pf-nachricht-action-modals
    #nachrichtActionModals
    (reload)="reload.emit($event)"
/>